





























































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import Pdf from "@/components/Pdf.vue";
import Video from "@/components/Video.vue";
import Footer from "@/components/Footer.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import { BIcon, BIconBoxArrowRight } from "bootstrap-vue";
@Component({
  components: {
    Header,
    Menu,
    Pdf,
    Video,
    BIcon,
    BIconBoxArrowRight,
    NextPrevBtn,
    Footer,
  },
})
export default class ProStrategy extends Vue {
  protected pdfStratShort = [
    {
      PdfLink: "/pdf_OWcom/Pro/ProLetter.pdf",
      PdfDownload: "LettreProdessionnelle",
      TxtPdf: "La lettre professionnelle",
    },

    {
      PdfLink: "/pdf_OWcom/Pro/ProResume.pdf",
      PdfDownload: "Resume",
      TxtPdf: "Le résumé",
    },

    {
      PdfLink: "/pdf_OWcom/Pro/ProReport.pdf",
      PdfDownload: "CompteRenduCritique",
      TxtPdf: "Le compte rendu critique",
    },
    {
      PdfLink: "/pdf_OWcom/Pro/ProArgument.pdf",
      PdfDownload: "ArgumentaireProjet",
      TxtPdf: "L'argumentaire de projet",
    },
    {
      PdfLink: "/pdf_OWcom/Pro/ProDissertation.pdf",
      PdfDownload: "DissertationCritique",
      TxtPdf: "La dissertation critique",
    },
  ];
  protected pdfInternship = [
    {
      PdfLink: "/pdf_OWcom/Pro/ProTrainee.pdf",
      PdfDownload: "RapportStage",
      TxtPdf: "La rapport de stage",
    },
  ];
  protected pdfTech = [
    {
      PdfLink: "/pdf_OWcom/Pro/ProTechnic.pdf",
      PdfDownload: "DocumentTechnique",
      TxtPdf: "Le document technique",
    },
  ];
  protected pdfHowTo = [
    {
      PdfLink: "/pdf_OWcom/Pro/ProGoodCommunication.pdf",
      PdfDownload: "BienCommuniquer",
      TxtPdf: "Communiquer à l'écrit",
    },
    {
      PdfLink: "/pdf_OWcom/Pro/ProRules.pdf",
      PdfDownload: "ReglesCommunication",
      TxtPdf: "Les Règles de la Communication",
    },
    {
      PdfLink: "/pdf_OWcom/Pro/ProSimplified.pdf",
      PdfDownload: "CommunicationSimplifié",
      TxtPdf: "Communication écrite simplifiée",
    },
  ]
  protected pdfPressConference = [
    {
      PdfLink: "/pdf_OWcom/Pro/ProPress.pdf",
      PdfDownload: "RedigerCommuniquePresse",
      TxtPdf: "Rédiger un communiqué",
    },
  ]
  protected pdfTechnicalDocumentation = [
    {
      PdfLink: "/pdf_OWcom/Pro/ProTechnical.pdf",
      PdfDownload: "FicheTechnique",
      TxtPdf: "Rédiger une fiche technique",
    },
  ]
  protected pdfStratSynthesis = [
    {
      PdfLink: "/pdf_OWcom/Pro/ProSynthesis.pdf",
      PdfDownload: "NoteSynthese",
      TxtPdf: "La note de synthèse",
    },
  ];
  protected pdfStraAssay = [
    {
      PdfLink: "/pdf_OWcom/Pro/ProAssay.pdf",
      PdfDownload: "Essai",
      TxtPdf: "L'essai",
    },
  ];
  protected pdfStraCritic = [
    {
      PdfLink: "/pdf_movie/write_critiscism_movie.pdf",
      PdfDownload: "Écrire une critique de film",
      TxtPdf: "Écrire une critique de film",
    },
    {
      PdfLink: "/pdf_movie/write_critiscism_movie2.pdf",
      PdfDownload: "Rédiger une critique de film",
      TxtPdf: "Rédiger une critique de film",
    },
    {
      PdfLink: "/pdf_movie/critiscism_movie.pdf",
      PdfDownload: "Critiquer un film",
      TxtPdf: "Critiquer un film",
    },
  ];

  protected videoStratShort = [
    {
      videoSrc: "https://www.youtube.com/embed/huU8hja6TXU",
      videoTitle: "La copie de concours (1re partie)",
      videoRoot: "Chaîne : E-Learning Physique",
    },
    {
      videoSrc: "https://www.youtube.com/embed/LMWJB8pvXks",
      videoTitle: "La copie de concours ? (2e partie - MP/PC/PSI)",
      videoRoot: "Chaîne : E-Learning Physique",
    },
  ];
  protected videoStratmemory = [
    {
      videoSrc: "https://www.youtube.com/embed/rgb_BzrvW2g",
      videoTitle: "Rédiger un mémoire – méthodologie",
      videoRoot: "Chaîne : digiSchool",
    },
    {
      videoSrc: "https://www.youtube.com/embed/V4KN8c2GMIM",
      videoTitle: "Comment rédiger un mémoire ?",
      videoRoot: "Chaîne :  Scribbr - Relecture & Correction",
    },
    {
      videoSrc: "https://www.youtube.com/embed/R4fHq8LcDRM",
      videoTitle: "10 astuces pour bien rédiger votre mémoire",
      videoRoot: "Chaîne : SYMPA",
    },
  ];
  protected nxtprevProStrategy = {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail1.png",
    NextImage: "/thumbnail5.png",
    PrevLink: "/Ecrit_Pro/Fondamentaux",
    NextLink: "/Ecrit_Pro/Orthographe",
  };
}
